import {
  WHATS_IN_MEMBERSHIP_W_IMAGES_EXP_FLAG,
  WhatsInMembershipWithImagesVariant,
} from 'experiments/pen-5368_v1_whats_in_membership_w_images'
import Experiment from '@mc/experiments-react'
import { useTranslation } from '@mc/i18n'
import { GiftButton } from '@mc/promos'
import { getPageSource, Locations, PageSource } from '@mc/track-event'
import { TrackingContainer } from '@mc/visibility'
import CTA from 'components/CTA'
import { trackValuePropViewed } from 'components/ValueProps'
import { ValuePropsList } from './ValuePropsList'

export const Subscription = ({
  eventProps = {},
  hideCtas = false, // pen-5196_v1
}: {
  eventProps?: Record<string, string | number | undefined>
  hideCtas?: boolean
}) => {
  const { t } = useTranslation('@mc/next')

  const pageSource = getPageSource()

  const location =
    pageSource === PageSource.HOMEPAGE
      ? Locations.WHAT_YOU_WILL_GET
      : Locations.WHATS_INCLUDED

  const trackProps = {
    location,
    category: 'whats-included',
    page_source: pageSource,
    ...eventProps,
  }

  return (
    <TrackingContainer onFirstVisible={trackValuePropViewed}>
      {hideCtas ? (
        <section className='container mc-my-10 d-flex flex-column justify-content-center align-items-center'>
          <h2 className='mc-text-h2 mc-mb-6 mc-text--center'>
            {t('subscription.title')}
          </h2>
          <ValuePropsList />
        </section>
      ) : (
        <section
          className='container mc-my-10'
          data-testid='subscription'
          id='whats-included'
        >
          <Experiment
            name={WHATS_IN_MEMBERSHIP_W_IMAGES_EXP_FLAG}
            default={() => (
              <div className='row align-items-center'>
                <div className='col-12 col-lg-6 mc-text--center mc-text-lg--left'>
                  <h2 className='mc-text-h2'>{t('subscription.title')}</h2>
                  <div className='mc-mt-6'>
                    <div className='d-flex justify-content-center justify-content-lg-start'>
                      <div className='col-6 col-sm-4'>
                        <CTA fullWidth trackProps={trackProps} />
                      </div>
                      <div className='col-6 col-sm-4'>
                        <GiftButton location={location} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-12 col-lg-5 offset-lg-1 d-flex justify-content-center'>
                  <ValuePropsList />
                </div>
              </div>
            )}
            variant_1={() => (
              <WhatsInMembershipWithImagesVariant
                trackProps={trackProps}
                location={location}
              />
            )}
          />
        </section>
      )}
    </TrackingContainer>
  )
}
